import React from 'react';
const SvgDwgThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 100 100" width="1em" height="1em" {...props}>
      <path fill="#C8D8EA" d="M11 3v95h79V29H64V3H11z" />
      <path fill="#9BB9D9" d="M64 3l25.7 25.9H64V3z" />
      <path fill="#2F649F" d="M15 7.1v42h17l54 29v-49H64v-22H15z" />
      <path opacity={0.302} fill="#1B3F63" d="M64 29h26v26L64 29z" />
      <path
        fill="#FFF"
        fillOpacity={0.9}
        d="M23 17h16v16H23V17zm-2-2v9h-6v2h6v9h9v17h2V35h9v-9h23v-2H41v-9h-9V7h-2v8h-9zm9 9v2h2v-2h-2z"
      />
      <path fill="#FDC137" d="M11 49h21l58 31v18H11V49z" />
      <g opacity={0.9}>
        <path d="M15.5 93.3V79h4.9c1.1 0 2 .1 2.5.2.8.2 1.5.5 2.1 1 .8.6 1.3 1.5 1.7 2.4.4 1 .6 2.1.6 3.4 0 1.1-.1 2.1-.4 2.9-.3.8-.6 1.5-1 2.1-.4.6-.8 1-1.3 1.3-.5.3-1 .6-1.7.7-.7.2-1.4.2-2.3.2h-5.1zm1.9-1.7h3.1c.9 0 1.7-.1 2.2-.3s1-.4 1.3-.7c.4-.4.8-1.1 1-1.8.3-.8.4-1.7.4-2.8 0-1.5-.2-2.6-.7-3.5-.5-.8-1.1-1.3-1.8-1.6-.5-.2-1.3-.3-2.5-.3h-3v11zM32.5 93.3L28.7 79h1.9l2.2 9.4c.2 1 .4 2 .6 2.9.4-1.5.6-2.4.6-2.6l2.7-9.7H39l2.1 7.2c.5 1.8.9 3.5 1.1 5.1.2-.9.4-1.9.7-3.1l2.2-9.2H47l-3.9 14.3h-1.8l-3-10.9c-.3-.9-.4-1.5-.4-1.7-.2.7-.3 1.2-.4 1.7l-3 10.9h-2zM55.6 87.7V86h6.1v5.3c-.9.7-1.9 1.3-2.9 1.7-1 .4-2 .6-3 .6-1.4 0-2.7-.3-3.8-.9-1.1-.6-2-1.5-2.6-2.6-.6-1.1-.9-2.4-.9-3.8s.3-2.7.9-3.9c.6-1.2 1.4-2.1 2.5-2.7 1.1-.6 2.4-.9 3.8-.9 1 0 2 .2 2.8.5.8.3 1.5.8 2 1.4.5.6.8 1.4 1.1 2.3l-1.7.5c-.2-.7-.5-1.3-.8-1.7-.3-.4-.8-.8-1.4-1-.6-.2-1.2-.4-2-.4-.9 0-1.6.1-2.2.4-.6.3-1.1.6-1.5 1-.4.4-.7.9-.9 1.4-.4.9-.5 1.8-.5 2.9 0 1.3.2 2.3.7 3.2.4.9 1.1 1.5 1.9 1.9.8.4 1.7.6 2.7.6.8 0 1.6-.2 2.4-.5.8-.3 1.4-.7 1.8-1v-2.7h-4.5z" />
      </g>
      <g fill="#2F649F">
        <path d="M84 11V8.3l1 2.7h1l1-2.7V11h1V6h-1l-1.5 3L84 6h-1v5h1zM81 7h1.3V6h-3.7v1H80v4h1V7z" />
      </g>
    </svg>
  );
});
export default SvgDwgThumbnail;
SvgDwgThumbnail.iconName = 'dwg-thumbnail';
SvgDwgThumbnail.displayName = 'SvgDwgThumbnail';
